'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Map, _handleActions;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _buildResponderMap = require('conversations-schema/responders/operators/buildResponderMap');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)((_Map = {}, _defineProperty(_Map, _senderTypes.AGENT, (0, _immutable.Map)()), _defineProperty(_Map, _senderTypes.BOT, (0, _immutable.Map)()), _Map));

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.GET_WIDGET_DATA_SUCCEEDED, function (responders, action) {
  var payload = action.payload;


  var botResponderList = payload.botResponder ? (0, _immutable.List)([payload.botResponder]) : (0, _immutable.List)();

  var allResponders = botResponderList.concat(payload.responders);

  return (0, _buildResponderMap.buildResponderMap)(allResponders, responders);
}), _defineProperty(_handleActions, ActionTypes.FETCH_AGENT_RESPONDER_SUCCEEDED, function (responders, action) {
  var payload = action.payload;

  var responderMap = (0, _buildResponderMap.buildResponderMap)([payload], responders);
  return responderMap;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/responders/reducers/responders.js
// module id = 612
// module chunks = 2 3